// API configuration with optional prefix support
const getApiUrl = () => {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    const apiPrefix = process.env.REACT_APP_API_PREFIX || '';
    
    // Ensure prefix starts with / if provided and doesn't end with /
    const normalizedPrefix = apiPrefix 
        ? (apiPrefix.startsWith('/') ? apiPrefix : `/${apiPrefix}`).replace(/\/$/, '')
        : '';
    
    return `${baseUrl}${normalizedPrefix}`;
};

export const CONFIG = {
    SERVER_URL: getApiUrl()
};